import type { Icon } from '../../../src/lib/types'
export const mdiDockRight: Icon = {
  "id": "dock-right",
  "name": "Dock Right",
  "path": "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M15 18H4V6H15Z",
  "as": [],
  "tags": []
}
export default mdiDockRight